export default __webpack_public_path__ + "static/media/Hashtag Hijacking Insights - 02 - Proper social media.65303d9e.pdf";